import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import './registerServiceWorker'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
//import SmartTable from 'vuejs-smart-table'
//import VueEasyLightbox, { useEasyLightbox } from 'vue-easy-lightbox'
//import 'vue-easy-lightbox/external-css/vue-easy-lightbox.css'; // Import CSS if needed

const appInstance = createApp(App);
//appInstance.config.globalProperties.$EndPoint='http://localhost:3000/api/';
appInstance.config.globalProperties.$EndPoint='https://dicora-customers-api.onrender.com/api/';
localStorage.setItem('IsLoggedIn',true);
appInstance.config.globalProperties.$SPClientId='0e252ca0-cd32-48d7-88e1-ff87a3c251e4';
appInstance.config.globalProperties.$SPClientSecret='GlJ8Q~2sJ0zsl3Oe1Jpq4WKZa~hJUxlQ4EktpapN';
appInstance.config.globalProperties.$SPTenantId='6441723f-0de2-4821-b8d7-d17a7a3a7948';
appInstance.config.globalProperties.$SPUrl='https://dicoracom.sharepoint.com';
appInstance.config.globalProperties.$SPEndPointUrl='https://dicoracom.sharepoint.com/sites/Instalaciones/_api/web';
appInstance.use(store);
//appInstance.use(SmartTable);
//appInstance.use(VueEasyLightbox);
appInstance.use(VueSweetalert2);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.mount("#app");
